import { useNavigate } from "react-router-dom";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import usePermission from "../../hooks/userAccess";

const ManageSubadmin = () => {
  const navigate = useNavigate();
  const { isView } = usePermission({
    label: 'Manage Sub-Admin',
    page_permission: 'isView',
  })

  return (
    <>
      <div className="main_title">
        <h1>Manage Sub-Admin</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Sub-Admin
        </p>
      </div>

      {isView && <div className="cards">
        <SubadminList />
      </div>}
    </>
  );
};

export default ManageSubadmin;
